<template>
  <div class="film pb-6 md:pb-8 border-b w-full">
    <div class="relative w-full">
      <swiper :options="filmOption" class="swiper w-full">
        <swiper-slide v-for="(item, index) in filmData" :key="index" class="item cursor-pointer flex flex-col">
          <a :href="item.url" target="_blank">
            <img :src="item.image_url" :alt="item.name">
            <p class="text-sm text-center mt-3">{{ item.name }}</p>
          </a>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-next focus:outline-none cursor-pointer hidden sm:block swiper-button-next-film mt-0 swiper-button-next-index"></div>
      <div class="swiper-button-prev focus:outline-none cursor-pointer hidden sm:block swiper-button-prev-film mt-0 swiper-button-prev-index"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filmData: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      filmOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        watchOverflow: true,
        loop: false,
        autoplay: {
          delay: 5000
        },
        breakpoints: {
          576: {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 20
          }
        },
        navigation: {
          nextEl: '.swiper-button-next-film',
          prevEl: '.swiper-button-prev-film'
        }
      }
    }
  }
}
</script>
